<template>
  <svg
    class="absolute inset-x-0 h-5 w-full"
    :class="{
      'top-0': isTop,
      'rotate-180 bottom-0': !isTop,
    }"
    viewBox="0 0 1500 20"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg">
    <defs>
      <mask id="invert-mask">
        <rect class="h-full w-full" fill="white" />
        <path d="M0 20H1500C1500 20 1087.25 0 718.125 0C349 0 0 20 0 20Z" fill="black" />
      </mask>
    </defs>
    <!-- Background that shows through the mask -->
    <rect class="h-full w-full" fill="inherit" mask="url(#invert-mask)" />
  </svg>
</template>

<script setup lang="ts">
type BorderPosition = 'top' | 'bottom'
const props = withDefaults(defineProps<{ position?: BorderPosition }>(), {
  position: 'top' as BorderPosition,
})

const isTop = props.position === 'top'
</script>
